/* Cart add-on offer — Soul Aesthetix (Out of the Sandbox / PXUTheme)

   Adds the offered product, then hands refreshing back to the theme's own
   ajax cart (PXUTheme.jsAjaxCart.updateView) rather than re-implementing it.
   updateView re-renders `.ajax-cart__details-wrapper`, which is where this
   panel lives, so the panel updates itself.

   Vanilla and delegated from document: no jQuery load-order dependency, and it
   survives the panel being replaced on every cart update. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* The theme's ajax cart — mini cart and drawer both go through this. */
  function refreshAjaxCart() {
    var theme = window.PXUTheme;
    if (theme && theme.jsAjaxCart && typeof theme.jsAjaxCart.updateView === 'function') {
      theme.jsAjaxCart.updateView();
      return true;
    }
    return false;
  }

  /* On the cart page the panel sits inside `.cart__form`, so swapping that
     element refreshes both the line items and the panel. Mirrors what
     jsAjaxCart.addToCart already does for the cart page. */
  function refreshCartPage() {
    var current = document.querySelector('.cart__form');
    if (!current) return Promise.resolve(false);

    return fetch(root + 'cart', { headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart fetch failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart__form');
        var target = document.querySelector('.cart__form');
        if (!next || !target) return false;
        target.replaceWith(next);
        return true;
      });
  }

  function refresh() {
    var ajaxRefreshed = refreshAjaxCart();
    return refreshCartPage().then(function (pageRefreshed) {
      // Neither surface is present — fall back rather than leave a stale cart.
      if (!ajaxRefreshed && !pageRefreshed) window.location.reload();
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-addon-add]');
    if (!button || button.disabled) return;

    // The panel renders inside the ajax cart's <form>; never let this submit.
    event.preventDefault();

    var variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    var panel = button.closest('[data-addon-offer]');
    var error = panel && panel.querySelector('[data-addon-error]');
    if (error) error.hidden = true;

    button.disabled = true;
    button.dataset.loading = 'true';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(
            function (body) {
              throw new Error(body.description || body.message || 'Add to cart failed');
            },
            function () {
              throw new Error('Add to cart failed: ' + res.status);
            }
          );
        }
        return refresh();
      })
      .catch(function (err) {
        console.error('[cart-addon-offer]', err);
        if (error) error.hidden = false;
        // The panel survives a failed add, so restore the button.
        button.disabled = false;
        delete button.dataset.loading;
      });
  });
})();
